export const citations = [
    {
        text: "Ce n’est pas quand il a découvert l’Amérique, mais quand il a été sur le point de la découvrir, que Colomb a été heureux.",
        author: "Fiodor Dostoïevski",
        book:"L'idiot",
        details: "L'idiot, 1875, page 3."
    },
    {
        text: "Que doit-on préférer : un bonheur facile ou des souffrances élevées ?.",
        author: "Fiodor Dostoïevski",
        book:"Les Démons",
        details: "Les Démons, 1875, page 3."
    },
]